module.exports = __webpack_public_path__ + "static/img/4en.9036e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/4en.png
// module id = /kIl
// module chunks = 0